import { Component } from '@angular/core'
import { RouterOutlet } from '@angular/router'
import { NavbarComponent } from '../navbar/navbar.component'
import { SidebarComponent } from '../sidebar/sidebar.component'

@Component({
  selector: 'base-template',
  imports: [RouterOutlet, NavbarComponent, SidebarComponent],
  templateUrl: './base.component.html',
  styleUrl: './base.component.scss',
})
export class BaseComponent {}
